<template>
  <div class="w-full flex justify-center items-center">
    <span class="text-sm mr-2">From</span>

    <span v-if="fromNow" class="text-sm font-bold mr-2">Now</span>

    <pl-select v-else v-model="time.from" class="w-48 mr-2" selectClass="w-full bg-white rounded border-grey-dark text-xs">
      <option v-for="t in timesFrom" :key="t">{{ t }}</option>
    </pl-select>

    <span class="text-sm mr-2">For</span>

    <pl-select v-model="time.duration" class="flex-no-shrink w-32" selectClass="w-full bg-white rounded border-grey-dark text-xs">
      <option v-for="duration in durations" :key="duration.value" :value="duration.value">{{ duration.text }}</option>
    </pl-select>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'TimePicker',

  props: ['value', 'startTime', 'fromNow'],

  data () {
    return {
      durations: [
        { text: '30 mins', value: 30 },
        { text: '1 hr', value: 60 },
        { text: '1 hr 30 mins', value: 90 },
        { text: '2 hrs', value: 120 }
      ],
      lastTime: moment().local().set({ hour: 20, minutes: 0, seconds: 0 })
    }
  },

  computed: {
    time: {
      get () {
        return this.value
      },

      set (value) {
        this.$emit('input', value)
      }
    },
    timesFrom () {
      const start = this.startTime.clone()
      let times = [start.format('HH:mm')]

      while (start.isBefore(this.lastTime)) {
        times.push(start.add(0.5, 'hours').format('HH:mm'))
      }

      return times
    }
  }
}
</script>
